module.exports = __webpack_public_path__ + "img/code-management.73ef2bec.png";